/**
 * GetPageSize
 *
 * Module to detect page/screen size
 *
 * @return { object }
 */

OT.createNS('OT.Common.Helpers.GetPageSize');

OT.Common.Helpers.getPageSize = function () {
    var $window = $(OT.Common.getWindow());

    return {
        width: $window.width(),
        height: $window.height(),
        screenWidth: window.screen.width,
        screenHeight: window.screen.height
    };
};